// import RootLayout from "./layouts/root-layout";
// import Loader from "./app/common/loader";
// import ScrollToTop from "./globals/scroll-to-top";
// import { useState, useEffect } from "react";
// import "./i18n"; // Initialize i18n

// function App() {
//   const [isLoading, setLoading] = useState(true);

//   useEffect(() => {
//     const timer = setTimeout(() => setLoading(false), 500);
//     return () => clearTimeout(timer);
//   }, []);

//   if (isLoading) return <Loader />;

//   return (
//     <>
//       <ScrollToTop />
//       <RootLayout />
//     </>
//   );
// }

// export default App;

import RootLayout from "./layouts/root-layout";
import Loader from "./app/common/loader";
import ScrollToTop from "./globals/scroll-to-top";
import { useState, useEffect } from "react";
import "./i18n";
import AutoRedirect from "./components/AutoRedirect";
import ProfileCheckRedirect from "./components/ProfileCheckRedirect"
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function App() {
  const [isLoading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 500);
    return () => clearTimeout(timer);
  }, []);

  if (isLoading) return <Loader />;

  return (
    <>
      <AutoRedirect />
      <ProfileCheckRedirect />
      <ScrollToTop />
      <RootLayout />
      <ToastContainer position="top-right" autoClose={4000} />
    </>
  );
}

export default App;
